/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Audio Play Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const NavAudioPlay = props => (
  <SvgIcon viewBox="0 0 19 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-3-2h24v24H-3z" />
      <path
        fill={props.color}
        d="M2.196.17l15.863 8.28a1.75 1.75 0 0 1 0 3.103l-15.863
        8.28A1.501 1.501 0 0 1 0 18.503V1.5A1.5 1.5 0 0 1 2.196.17z"
      />
    </g>
  </SvgIcon>
);

NavAudioPlay.propTypes = {
  color: PropTypes.string
};

NavAudioPlay.defaultProps = {
  color: '#047B9C'
};

export default NavAudioPlay;



// WEBPACK FOOTER //
// ./src/js/icons/NavAudioPlay.jsx